<div class="order-transfer-skus">
  <form [formGroup]="form">
    <mat-card class="lum-mat-card">
      <mat-card-content>
        <div class="order-transfer-skus__actions flex gap-2 justify-end">
          <button
            type="button"
            loading
            class="lum-button lum-button--secondary"
            (click)="onOpenLineItemsDialog()"
          >
            <lum-ui-icon
              color="#5563d6"
              width="10"
              height="10"
              class="mr-2"
              icon="add-circle"
            ></lum-ui-icon>
            Add Multiple Line Items
          </button>
        </div>

        <div class="mt-4 w-100">
          <div class="flex">
            <div class="grow">
              <lum-rfq-scan-mode-input
                [loading]="(loading$ | async) || false"
                [rfqs]="rfqs"
                [debounceTime]="0"
                [scanSearchStr]="scanSearchStr"
                (inputChangeEvent)="onSearchRfqs($event, true)"
                (selectSkuEvent)="onSelectSkuFromScanMode($event)"
              ></lum-rfq-scan-mode-input>
            </div>

            <div class="flex justify-content-end">
              <button
                [disabled]="!lineItemsFormArray?.length || !hasSelectedItems"
                type="button"
                class="lum-button lum-button--secondary"
                mat-button
                [matMenuTriggerFor]="menu"
              >
                Bulk Update
                <lum-ui-icon class="ml-2" icon="edit" color="#5563d6">
                </lum-ui-icon>
              </button>
              <mat-menu class="lum-mat-menu" #menu="matMenu">
                <button mat-menu-item (click)="onBulkUpdateUOM()">
                  Bulk Update UOM
                </button>
                <button (click)="onBulkUpdateQuantity()" mat-menu-item>
                  Bulk Update Quantity
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="flex gap-2 mt-4">
          <input
            type="text"
            placeholder="Search SKU or Product Name in Line Items Table..."
            matInput
            class="lum-input"
            (input)="onSearchInputChange($event)"
          />
        </div>
        <lum-rfq-table-form
          [form]="form"
          [searchableFields]="searchableFields"
          [searchStr]="searchStr"
          [rfqs]="rfqs"
          [loadingRfqs]="loadInitialRfq || false"
          [fromEnterEvent]="fromEnterEvent"
          [fromTransferOrder]="true"
          [columns]="displayColumns"
          (removeLineItem)="removeLineItem.emit($event)"
          (addRowItems)="addRowItems.emit($event)"
          (searchRfq)="onSearchRfqs($event, false)"
          (enterRfqEvent)="onEnterRfqEvent($event)"
          (selectRfq)="selectRfq.emit($event)"
          (scrollPaginate)="onPaginateRfqs($event)"
        ></lum-rfq-table-form>

        <div class="flex flex-column">
          <div class="flex justify-end mb-4">
            <div class="table__summary-section">
              <div class="flex p-2">
                <div class="flex w-100 justify-end table__summary-label-shipping">
                  Shipping Cost
                </div>
                <div class="flex w-100 justify-end">
                  <input
                    type="number"
                    inputmode="numeric"
                    class="lum-input text-right w-25"
                    formControlName="shippingCost"
                    matInput
                    [ngClass]="{
                      error:
                        form.get('shippingCost')?.touched &&
                        form.get('shippingCost')?.invalid,
                    }"
                  />
                </div>
              </div>
              <mat-error
                *ngIf="
                  form.get('shippingCost')?.touched &&
                  form.get('shippingCost')?.invalid
                "
                class="text-right"
                ><small class="text-red"> This field is required </small></mat-error
              >
            </div>
          </div>
          <div class="flex justify-end">
            <div class="flex p-2 table__summary-section">
              <div class="flex w-100 justify-end table__summary-label">
                Total Cost
              </div>
              <div class="flex w-100 justify-end">
                <b>{{ itemsCost | currency }}</b>
              </div>
            </div>
          </div>

          <div class="flex justify-end">
            <div class="flex p-2 table__summary-section">
              <div class="flex w-100 justify-end table__summary-label">
                Net Total
              </div>
              <div class="flex w-100 justify-end">
                <b>{{ netTotal | currency }}</b>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>
